
//治疗表详情
export const ACTION_GET_MSG_LIST = 'ACTION_GET_MSG_LIST';
